/**
 * İş emirleri metinleri (S46; ürün spesifikasyonu dalga-a-is-emirleri.md bölüm 19.5, 08 §9.1). Çalışanın "İşe başla" ve "İşi tamamla"
 * retlerinin sebep kodları (`workorder_*`): yürütme kaydının ve `CheckpointFailed` zaman çizelgesi kaydının `reasonCode`'u, punch problem
 * gövdesinin `actionReason`'ı. Verification'ın hedef kodları (`target_*`, yöneticiye kısa adları `verification.reasons`'ta) iş emri ekranında
 * buradaki karşılığıyla gösterilir (`target_geo_outside` → `workorder_geo_outside`; eşleme WorkOrders'ta `WorkOrderReasonCodes.FromVerification`).
 * Bilinmeyen kodda sunucunun `detail` metni gösterilir. Ekranlar S47'dedir. Terimler: "İşe başla", "İşi tamamla", "İşe devam et" ("Mesaiye
 * başla" değil), "Konum sınırı", "Okutma noktası"; hitap "siz".
 */
export const workorders = {
  actions: {
    start: 'İşe başla',
    complete: 'İşi tamamla',
    resume: 'İşe devam et',
    retry: 'Tekrar dene',
  },
  // Sonuç ekranı (punch'ın `message`'ı ile aynı).
  results: {
    started: 'İşe başladınız.',
    completed: 'İş tamamlandı.',
    submitted: 'İşi tamamladınız. Tamamlama onay bekliyor.',
  },
  // Çalışana söylenen sebep (bölüm 19.5). Yer tutucular problem gövdesinin `location` alanından ({place}, {distance}, {radius},
  // {accuracy}, {limit}) ve eksik kanıt özetinden ({summary}) doldurulur.
  reasons: {
    workorder_geo_outside:
      'Konum doğrulanamadı: {place} yaklaşık {distance} m uzakta. İşlem yalnız {radius} m içinde yapılabilir. Noktaya yaklaşıp tekrar deneyin.',
    workorder_geo_low_accuracy: 'Konum net alınamadı (±{accuracy} m); en çok ±{limit} m gerekiyor. Açık alana çıkıp tekrar deneyin.',
    workorder_geo_unavailable: 'Konumunuza erişilemedi. Bu işlem için konum gerekiyor.',
    workorder_scan_required: 'Bu işlem için noktadaki QR kodu okutmanız gerekiyor.',
    workorder_wrong_entry_point: 'Bu QR bu işlemin okutma noktasına ait değil.',
    workorder_location_unavailable: 'Bu işlemin konumu tanımlı değil. Yöneticinize başvurun.',
    workorder_not_assigned: 'Bu işlem bulunamadı ya da size ait değil.',
    workorder_invalid_state: 'İş emrinin durumu bu işleme uygun değil.',
    workorder_proofs_missing: 'İş henüz tamamlanamaz. Eksik: {summary}.',
    // S47 (WO-KV-09): şirket açık mesaiyi zorunlu kıldıysa "İşe başla" mesai dışında reddedilir (punch'ın `actionReason`'ı; iş sayfasının
    // `primaryActionBlockedReason`'ı).
    workorder_session_required: 'Bu işe başlamak için önce mesaiye başlamanız gerekiyor.',
    workorder_verification_failed: 'Doğrulama tamamlanamadı. Tekrar deneyin.',
  },
  // Yöneticiye kısa adlar (zaman çizelgesindeki başarısız kontrol noktası, yürütme kaydı).
  reasonNames: {
    workorder_geo_outside: 'Konum sınırının dışında',
    workorder_geo_low_accuracy: 'Konum doğruluğu yetersiz',
    workorder_geo_unavailable: 'Konum alınamadı',
    workorder_scan_required: 'QR okutulmadı',
    workorder_wrong_entry_point: 'Başka okutma noktasının QR kodu',
    workorder_location_unavailable: 'Kontrol noktasının konumu tanımlı değil',
    workorder_not_assigned: 'Atanan çalışan değil',
    workorder_invalid_state: 'İş emrinin durumu uygun değil',
    workorder_proofs_missing: 'Zorunlu kanıt eksik',
    workorder_session_required: 'Açık mesai yok',
    workorder_verification_failed: 'Doğrulama tamamlanamadı',
  },
} as const;
